export const WHITE = '#ffffff';

export const BLACK = '#000000';

export const SHADOW = '#e6e6e6';

export const MANGO = {
  100: '#FFF5EB',
  200: '#E6E9ED',
  300: '#FF9D5C',
  400: '#AAB2BD',
  500: '#FF7416',
  900: '#F56200'
};

export const BLUE = {
  100: '#E8F3FD',
  200: '#A6CEF5',
  300: '#63AAED',
  500: '#2286E6',
  700: '#1673CA',
  800: '#185EA1',
  900: '#124E8F'
};

export const GREY = {
  100: '#F5F7FA',
  200: '#E6E9ED',
  300: '#CCD1D9',
  400: '#AAB2BD',
  500: '#656D78',
  900: '#353B48',
  A400: '#656D78' // main or A400 key is required for TS MUI Color definition
};

export default {
  common: {
    black: BLACK,
    white: WHITE
  },
  shadow: SHADOW,
  grey: GREY,
  primary: {
    main: BLUE[700],
    smoke: BLUE[100],
    light: BLUE[200],
    medium: BLUE[300],
    dark: BLUE[800],
    darkest: BLUE[900], // Used for kw aggregation data bar chart [DO NOT REMOVE]
    darker: '#2B5C86', // Styleguide primary-darker               [DO NOT REMOVE]
    lighter: '#cfe2f2', // Styleguide primary-lighter             [DO NOT REMOVE]
    contrastText: WHITE
  },
  mango: {
    main: MANGO[500],
    light: MANGO[100],
    dark: MANGO[900],
    contrastText: WHITE
  },
  success: {
    dark: '#008A18',
    medium: '#00C622',
    main: '#4CD763',
    light: '#B2EEBC',
    smoke: '#E5F9E8',
    contrastText: '#fff'
  },
  warning: {
    dark: '#B27500',
    medium: '#FFA700',
    main: '#FFC14C',
    light: '#FFDC99',
    smoke: '#FFF6E5',
    contrastText: '#fff'
  },
  error: {
    dark: '#AB0000',
    medium: '#F50000',
    main: '#F84C4C',
    light: '#FB9999',
    smoke: '#FEE5E5',
    contrastText: '#fff'
  },
  turquoise: {
    darker: '#288f7e',
    dark: '#34AD99',
    main: '#4FCEB9',
    light: '#9fe4d9',
    lighter: '#effaf8',
    contrastText: '#fff'
  },
  emerald: {
    darker: '#1b7943',
    dark: '#27AE60',
    main: '#2ECC71',
    light: '#7ee2a8',
    lighter: '#d1f5e0',
    contrastText: '#fff'
  },
  amethyst: {
    darker: '#5f486b',
    dark: '#836990',
    main: '#9476A3',
    light: '#c4b3cc',
    lighter: '#f3f0f5',
    contrastText: '#fff'
  },
  competitor: {
    dark: '#005A3E',
    main: '#1C8F77',
    light: '#3CD3D9'
  },
  thirdParty: {
    google: {
      main: '#0F9D58',
      light: '#29B772',
      secondary: '#4285F4',
      secondaryLight: '#5C9FFF'
    },
    facebook: {
      main: '#4267B2',
      light: '#5C81CC'
    }
  },
  navy: {
    light: '#E2EBF3',
    main: '#152637',
    smoke: '#1C334A',
    dark: '#111F2C',
    contrastText: '#FFFFFF'
  },
  sky: {
    light: '#EBF7FE',
    main: '#119FF7',
    smoke: '#B0DFFC',
    dark: '#077CC5',
    contrastText: '#FFFFFF'
  },
  lemon: {
    light: '#F8FCD9',
    main: '#D6F025',
    smoke: '#E5F679',
    dark: '#B8D20F',
    contrastText: '#152637'
  }
};
